import { Theme } from '../types';

export const lightTheme: Theme = {
  name: 'light',
  colors: {
    gray: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1e293b',
      900: '#0f172a',
    },
    accent: {
      50: '#f5f7ff',
      100: '#ebeeff',
      200: '#d4ddff',
      300: '#b4c3ff',
      400: '#8a9fff',
      500: '#667eea',
      600: '#5a67d8',
      700: '#4c51bf',
      800: '#434190',
      900: '#3c366b',
    },
    semantic: {
      success: '#48bb78',
      successLight: '#c6f6d5',
      error: '#f56565',
      errorLight: '#fed7d7',
      warning: '#ed8936',
      warningLight: '#feebc8',
      info: '#4299e1',
      infoLight: '#bee3f8',
    },
    background: {
      app: '#f8fafc',
      surface: '#ffffff',
      elevated: '#ffffff',
      navbar: '#ffffff',
      sidebar: '#f1f5f9',
      hover: '#f1f5f9',
      active: '#e2e8f0',
      blueprint: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    },
    text: {
      primary: '#0f172a',
      secondary: '#475569',
      tertiary: '#64748b',
      disabled: '#94a3b8',
      inverse: '#ffffff',
      accent: '#5a67d8',
      onAccent: '#ffffff',
      muted: '#64748b',
    },
    border: {
      color: '#e2e8f0',
      light: '#f1f5f9',
      medium: '#cbd5e1',
    },
    button: {
      bg: '#f8fafc',
      bgHover: '#f1f5f9',
      bgActive: '#e2e8f0',
      text: '#334155',
      border: '#cbd5e1',
      primary: {
        bg: '#667eea',
        bgHover: '#5a67d8',
        bgActive: '#4c51bf',
        text: '#ffffff',
      },
      disabled: {
        bg: '#f1f5f9',
        text: '#94a3b8',
        border: '#e2e8f0',
      },
    },
    input: {
      bg: '#ffffff',
      border: '#cbd5e1',
      borderHover: '#94a3b8',
      borderFocus: '#667eea',
      text: '#0f172a',
      placeholder: '#94a3b8',
    },
    toggle: {
      bg: '#cbd5e1',
      bgActive: '#667eea',
      thumb: '#ffffff',
    },
    executing: '#ff6b35',
    focus: '#667eea',
    overlay: {
      light: 'rgba(0, 0, 0, 0.1)',
      medium: 'rgba(0, 0, 0, 0.2)',
      heavy: 'rgba(0, 0, 0, 0.3)',
      white: 'rgba(255, 255, 255, 0.1)',
    },
    shadow: {
      medium: 'rgba(0, 0, 0, 0.15)',
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
    // Legacy spacing
    small: '8px',
    medium: '16px',
    large: '24px',
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '30px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    text: {
      xs: '12px',
      small: '14px',
      medium: '16px',
    },
  },
  borderRadius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    full: '9999px',
    // Legacy border radius
    small: '3px',
    medium: '8px',
  },
  shadows: {
    xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    sm: '0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 2px -1px rgba(0, 0, 0, 0.08)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.08)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.08)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.08)',
  },
  zIndex: {
    dropdown: 100,
    sticky: 200,
    overlay: 500,
    modal: 1000,
    toast: 2000,
    // Legacy z-index
    base: 0,
    accent: 5,
    content: 10,
    floating: 20,
  },
  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    base: '200ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '300ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
};